class BaseKinesisEvent {
  private readonly location: string | null;

  constructor(private readonly event_name: string, locationSource?: string) {
    this.location = locationSource || null;
  }
}

export default BaseKinesisEvent;
